<template>

  <div class="tabContent" v-if="user" :key="form_key">
    <div class="designForm" elevation="2" padding="20">
      <div style="flex:1; margin-bottom: 14px; display: flex;">
        <draggable element="div" data-collapsible="accordion" :list="formFields"
          :class="['noselect collapsible ', !formFields.length ? 'empty' : '', isDragged || isDragging ? 'dragging' : '', getSystemLanguage == 'english' ? 'dropArea' : '', getSystemLanguage == 'pashto' ? 'dropAreaPashto' : '', getSystemLanguage == 'dari' ? 'dropAreaDari' : '' ]"
          :options="formOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false"
          data-content="Drag and drop your fields here">
          <div style="position:relative" v-for="(item, index) in formFields" :key="index" :ref="'itm_'+index" :class="['input-container',
           !isDragging ? 'input-box' : '', !item.isPrevious && viewedForm && viewedForm.get('status') != 'pending' ? 'item_border' : '' ,
            isBeingDragged(index) ? 'no-show': ''
           ] ">

            <div class="showButton" style="position: relative; float:right;">
              <va-button
                v-if="formStatus == 'new' || (viewedForm && (viewedForm.get('status') == 'pending' || !item.isPrevious))"
                style="zoom:0.8; position: absolute; right:10px; top:30px" type="default"
                @click.native="destroy(index)">{{_("DELETE")}}
              </va-button>
              <va-button v-else style="zoom:0.8; position: absolute; right:10px; top:30px" type="default">
                {{_("NOT REMOVABLE")}} </va-button>
            </div>

            <div class="showButton"
              style="pointer-events:none;position: absolute; left:50%; top:50%; margin-top:-14px; opacity: .1;">
              <va-icon class="" style="zoom:2" type="pencil-alt" />
            </div>

            <div class="collapsible-header">
              <h1 v-if="item.type=='heading'" @click="editField(item.name, item.type, item.fieldDatabaseName)">{{
                getItemLabel(item) }}</h1>

              <p @click="editField(item.name, item.type, item.fieldDatabaseName)"><span v-if="item.type=='description'">{{
                  getItemLabel(item)
                  }}</span></p>

              <div @click="editField(item.name, item.type, item.fieldDatabaseName)"
                v-if="item.type=='single-geolocation' || item.type=='multiple-geolocation'">
                <span class="field_label">{{ getItemLabel(item) || _('Geo Location')}}</span>
                <img
                  :class="{multiple_geo: item.type=='multiple-geolocation', single_geo: item.type=='single-geolocation'}"
                  src="@/assets/map.jpeg" alt="google map"><br>
                <va-button style="pointer-events:none; margin-right: 10px;" type="info" disabled>{{
                  _('Get Current Location') }}</va-button>
                <span style="color:#848890; padding: 0 0 0 2px; font-size: 12px">{{getItemNote(item)
                  || item.pashtoNote
                  }}</span>
              </div>

              <div @click="editField(item.name, item.type, item.fieldDatabaseName)" v-if="item.type=='text'">
                <span class="field_label">{{ getItemLabel(item) || _('Small Text')}}</span>
                <va-input disabled :placeholder="getPlaceholder(item)" :type="item.fieldType"></va-input>
                <span style="color:#848890; padding: 0 0 0 2px; font-size: 12px">{{getItemNote(item)
                  }}</span>
              </div>

              <div @click="editField(item.name, item.type, item.fieldDatabaseName)" v-if="item.type=='attachment'">
                <span class="field_label">{{ getItemLabel(item) || _('File Attachment')}}</span>
                <va-input disabled type="file" id="attachment" name="attachment"></va-input>
                <span style="color:#848890; padding: 0 0 0 2px; font-size: 12px">{{getItemNote(item)
                  }}</span>
              </div>

              <div @click="editField(item.name, item.type, item.fieldDatabaseName)" v-if="item.type=='date'">
                <span class="field_label">{{ getItemLabel(item) || _('Date')}}</span>
                <va-datepicker disabled format="MM/dd/yyyy"></va-datepicker><br>
                <span style="color:#848890; padding: 0 0 0 2px; font-size: 12px">{{getItemNote(item)
                  }}</span>
              </div>

              <div @click="editField(item.name, item.type, item.fieldDatabaseName)" v-if="item.type=='percentage'">
                <span class="field_label">{{ getItemLabel(item) || _('Percentage')}}</span>
                <va-input disabled type="number" id="percentage" name="percentage" :placeholder="getPlaceholder(item)">
                </va-input>
                <span style="color:#848890; padding: 0 0 0 2px; font-size: 12px">{{getItemNote(item)
                  }}</span>
              </div>

              <div @click="editField(item.name, item.type, item.fieldDatabaseName)" v-if="item.type=='textarea'">
                <span class="field_label">{{ getItemLabel(item) || _('Large Text')}}</span>
                <va-textarea disabled :placeholder="getPlaceholder(item)"></va-textarea>
                <span style="color:#848890; padding: 0 0 0 2px; font-size: 12px">{{getItemNote(item)
                  }}</span>
              </div>

              <div @click="editField(item.name, item.type, item.fieldDatabaseName)" v-if="item.type=='checkbox'">
                <span class="field_label">Yes/No</span>
                <va-checkbox class="option_label" style="    pointer-events: none;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;">
                  {{ getItemLabel(item) || _('Yes/No')}}
                </va-checkbox><br>
                <span style="color:#848890; padding: 0 0 0 2px; font-size: 12px">{{getItemNote(item)
                  }}</span>
              </div>

              <div @click="editField(item.name, item.type, item.fieldDatabaseName)" v-if="item.type=='multiple-option'">
                <span class="field_label">{{ getItemLabel(item) || _('Multiple Option')}}</span>
                <va-checkbox-group vertical>
                  <va-checkbox class="option_label" style="pointer-events:none" v-for="option in item.options">{{
                    getItemLabel(option)
                    }}</va-checkbox>
                </va-checkbox-group><br>
                <span style="color:#848890; padding: 0 0 0 2px; font-size: 12px">{{getItemNote(item)
                  }}</span>
              </div>

              <div @click="editField(item.name, item.type, item.fieldDatabaseName)" v-if="item.type=='single-option'">
                <span class="field_label">{{ getItemLabel(item) || _('Single Option')}}</span>
                <p>{{ }}</p>
                <va-radio-group v-model="singleOptionChecked" vertical>
                  <va-radio style="pointer-events:none" v-for="option in item.options" label="option.value">{{
                    getItemLabel(option) }}</va-radio>
                </va-radio-group><br>
                <span style="color:#848890; padding: 0 0 0 2px; font-size: 12px">{{getItemNote(item)
                  }}</span>
              </div>

              <div @click="editField(item.name, item.type, item.fieldDatabaseName)" v-if="item.type=='select'">
                <span class="field_label">{{ getItemLabel(item) || _('List Selection')}}</span>
                <va-select style="pointer-events:none" type="default" class="select-border"
                  placeholder="Select an option" size="md">
                  <va-option v-for="option in item.options" :value="option.value">{{ getItemLabel(option) }}</va-option>
                </va-select><br>
                <span style="color:#848890; padding: 0 0 0 2px; font-size: 12px">{{getItemNote(item)
                  }}</span>
              </div>

            </div>

          </div>
        </draggable>
      </div>

    </div>

    <!-- <va-affix  class="itemsForm">
      
    </va-affix> -->
    <va-card style="padding-top: 10px;
    padding-bottom: 10px;
    width: 25%;
    position: relative;" :elevation="4" :padding="10">
      <h3 style="text-align: center; border-bottom: 1px solid #ddd; padding-bottom: 14px;">{{ _('Add Fields') }}</h3>
      <draggable element="ul" :list="components" class="collection dragArea" :options="componentsOptions"
        :clone="onClone" @start="isDragged=true" @end="isDragged=false">
        <li
          v-if="(($route.matched[0].name != 'surveys' && component.type != 'attachment') || ($route.matched[0].name == 'surveys' ))"
          v-for="component in components" class="collection-item">
          <img width="42" height="42" :src="getIcon(component.type)"> {{getComponentLabel(component)}}
        </li>

        <li v-else-if="component.type != 'attachment' && $route.matched[0].name == 'surveys'"
          v-for="component in components" class="collection-item_rtl">
          {{ getComponentLabel(component) }} <img width="42" height="42" :src="getIcon(component.type)">
        </li>
      </draggable>
      <div v-if="formFields.length > 0 &&  formStatus == 'new'"
        style="display:flex; justify-content: center; margin-top: 14px; zoom:.9;">
        <va-button @click.native="clearItems" type="danger" size="lg">{{ _('RESET FORM') }}</va-button>
      </div>

    </va-card>

    <!--  edit field modal----------------------------------------------------------------------------------------------- ‍ -->
    <va-modal :title="_('Edit Field')" style="overflow-y: auto;" width="900px" ref="editFieldModal"
      :backdrop-clickable="true" @confirm="confirmEditField" @hide="hideEditField">
      <div slot="body" style="padding: 30px">

        <va-row :gutter="12" v-if="beingEditedFieldType == 'heading'">

          <va-column :lg="getGrid" :md="getGrid" :sm="getGrid" v-if="formLanguages.includes('english')">
            <p class="field_label">Heading *</p>
            <va-input @keyup.native.enter="confirmEditField" v-model="englishHeading" showClean
              placeholder="Heading in english" name="heading" />
          </va-column>

          <va-column :lg="getGrid" :md="getGrid" :sm="getGrid" v-if="formLanguages.includes('pashto')">
            <p class="field_label">سرلیک *</p>
            <va-input @keyup.native.enter="confirmEditField" v-model="pashtoHeading" showClean
              placeholder="عنوان په پښتو" name="heading" />
          </va-column>

          <va-column :lg="getGrid" :md="getGrid" :sm="getGrid" v-if="formLanguages.includes('dari')">
            <p class="field_label">عنوان *</p>
            <va-input @keyup.native.enter="confirmEditField" v-model="dariHeading" showClean placeholder="عنوان در دری"
              name="heading" />
          </va-column>
        </va-row>

        <va-row :gutter="12" v-if="beingEditedFieldType == 'description'">

          <va-column :lg="getGrid" :md="getGrid" :sm="getGrid" :xs="getGrid" v-if="formLanguages.includes('english')">
            <p class="field_label">description in english *</p>
            <va-input v-model="englishDescription" showClean name="englishDescription" />
          </va-column>

          <va-column :lg="getGrid" :md="getGrid" :sm="getGrid" :xs="getGrid" v-if="formLanguages.includes('pashto')">
            <p class="field_label"> تفصیل په پښتو *</p>
            <va-input v-model="pashtoDescription" showClean name="pashtoDescription" />
          </va-column>

          <va-column :lg="getGrid" :md="getGrid" :sm="getGrid" v-if="formLanguages.includes('dari')">
            <p class="field_label">تفصیل در دری *</p>
            <va-input v-model="dariDescription" showClean name="dariDescription" />
          </va-column>
        </va-row>

        <div v-if="beingEditedFieldType !== 'description' && beingEditedFieldType !== 'heading'">

          <va-row
            v-if="(formStatus == 'new' || (viewedForm && (viewedForm.get('status') == 'pending' || !openedField.isPrevious))) && !showFieldDatabaseNameInput"
            :gutter="12">
            <va-column :lg="12" :md="12" :sm="12" v-if="userIsTyping">
              <p style="word-wrap: break-word" class="field_label">
                {{getFieldDatabaseNameTitle}} :<br> {{ fieldDatabaseName }}
                <va-button type="subtle" v-if="fieldDatabaseName !== ''" @click.native="showFieldDatabaseNameTextInput">
                  <va-icon type="pencil-alt" style="zoom: 0.9;" color="#999"></va-icon>
                </va-button>
              </p>
            </va-column>
          </va-row>

          <va-row
            v-else-if="(formStatus == 'new' || (viewedForm && (viewedForm.get('status') == 'pending' || !openedField.isPrevious))) && showFieldDatabaseNameInput"
            :gutter="12" v-else>
            <va-column :lg="getGrid" :md="getGrid" :sm="getGrid" :xs="getGrid" v-if="formLanguages[0] == 'english'">
              <p class="field_label">field name for database</p>
              <va-input v-model="englishFieldNameForDatabase"></va-input>
            </va-column>

            <va-column :lg="getGrid" :md="getGrid" :sm="getGrid" :xs="getGrid" v-if="formLanguages[0] == 'pashto'">
              <p class="field_label">د ډېټابېس لپاره د پوښتنې انګليسي نوم *</p>
              <va-input v-model="pashtoFieldNameForDatabase"></va-input>
            </va-column>

            <va-column :lg="getGrid" :md="getGrid" :sm="getGrid" :xs="getGrid" v-if="formLanguages[0] == 'dari'">
              <p class="field_label">اسم سوال در انګلیسی برای دیتابیس *</p>
              <va-input v-model="dariFieldNameForDatabase"></va-input>
            </va-column>
          </va-row>

          <va-row :gutter="12">
            <va-column :lg="getGrid" :md="getGrid" :sm="getGrid" :xs="getGrid" v-if="formLanguages.includes('english')">
              <p class="field_label">field label in english *</p>
              <va-input v-model="englishLabel" showClean name="englishField" />
            </va-column>

            <va-column :lg="getGrid" :md="getGrid" :sm="getGrid" :xs="getGrid" v-if="formLanguages.includes('pashto')">
              <p class="field_label">پوښتنه په پښتو *</p>
              <va-input v-model="pashtoLabel" showClean name="pashtoField" />
            </va-column>

            <va-column :lg="getGrid" :md="getGrid" :sm="getGrid" :xs="getGrid" v-if="formLanguages.includes('dari')">
              <p class="field_label">سوال در دری *</p>
              <va-input v-model="dariLabel" showClean name="dariField" />
            </va-column>
          </va-row>

          <va-row :gutter="12">
            <va-column :lg="getGrid" :md="getGrid" :sm="getGrid" :xs="getGrid" v-if="formLanguages.includes('english')">
              <p class="field_label">Note in english</p>
              <va-input v-model="fieldEnglishNote" showClean name="fieldEnglishNote" />
              </va-textarea>
            </va-column>

            <va-column :lg="getGrid" :md="getGrid" :sm="getGrid" :xs="getGrid" v-if="formLanguages.includes('pashto')">
              <p class="field_label">نوټ په پښتو </p>
              <va-input v-model="fieldPashtoNote" showClean name="fieldPashtoNote" />
            </va-column>

            <va-column :lg="getGrid" :md="getGrid" :sm="getGrid" :xs="getGrid" v-if="formLanguages.includes('dari')">
              <p class="field_label">نوت در دری </p>
              <va-input v-model="fieldDariNote" showClean name="fieldDariNote" />
            </va-column>
          </va-row>

          <va-row :gutter="12" style="margin: 10px 0 10px 0px">
            <va-column :lg="3" :md="3" :sm="12">
              <va-checkbox v-model="isRequired">{{ _('Mandatory') }}</va-checkbox>
            </va-column>

            <va-column
              v-if="(formStatus == 'new' || (viewedForm && (viewedForm.get('status') == 'pending' || !openedField.isPrevious))) && beingEditedFieldType == 'text'"
              :lg="4" :md="4" :sm="12">
              <va-radio-group v-model="textFieldType">
                <va-radio checked label="text">{{ _('Text') }}</va-radio>
                <va-radio label="number">{{ _('Number') }}</va-radio>
              </va-radio-group>
            </va-column>

            <va-column :lg="4" :md="4" :sm="12"
              v-if="(formStatus == 'new' || (viewedForm && (viewedForm.get('status') == 'pending' || !openedField.isPrevious))) && (beingEditedFieldType == 'select' || beingEditedFieldType == 'attachment')">
              <va-checkbox @change="setMultipleSelectionValue" :checked="multipleSelection" :value="multipleSelection">
                {{ _('Multiple Selection') }}
              </va-checkbox>
            </va-column>

            <va-column :lg="4" :md="4" :sm="12">
              <va-checkbox @change="setFieldEditableValue" :checked="editable" :value="editable">
                {{ _('Editable') }}
              </va-checkbox>
            </va-column>

            <va-column
              v-if="(formStatus == 'new' || (viewedForm && (viewedForm.get('status') == 'pending' || !openedField.isPrevious))) && beingEditedFieldType == 'date'"
              :lg="4" :md="4" :sm="12">
              <va-checkbox @change="setFieldIsTimeValue" :checked="isTime" :value="isTime">
                {{ _('Is Time') }}
              </va-checkbox>
            </va-column>
            <va-column
              v-if="(formStatus == 'new' || (viewedForm && (viewedForm.get('status') == 'pending' || !openedField.isPrevious))) && beingEditedFieldType == 'date'"
              :lg="4" :md="4" :sm="12">
              <va-checkbox @change="setFieldIsHijriValue" :checked="isHijri" :value="isHijri">
                {{ _('Is hijri shamsi date?') }}
              </va-checkbox>
            </va-column>
          </va-row>

          <va-row :gutter="12">
            <va-column :lg="getGrid" :md="getGrid" :sm="getGrid" :xs="getGrid"
              v-if="formLanguages.includes('english') && (beingEditedFieldType == 'text' || beingEditedFieldType == 'textarea' || beingEditedFieldType == 'percentage')">
              <p class="field_label">Placeholder</p>
              <va-input v-model="fieldEnglishPlaceholder" showClean placeholder="Type a placeholder"
                name="fieldEnglishPlaceholder" />
            </va-column>

            <va-column :lg="getGrid" :md="getGrid" :sm="getGrid" :xs="getGrid"
              v-if="formLanguages.includes('pashto') && (beingEditedFieldType == 'text' || beingEditedFieldType == 'textarea' || beingEditedFieldType == 'percentage')">
              <p class="field_label">پلیډونکی</p>
              <va-input v-model="fieldPashtoPlaceholder" showClean placeholder="پلیډونکی"
                name="fieldPashtoPlaceholder" />
            </va-column>

            <va-column :lg="getGrid" :md="getGrid" :sm="getGrid" :xs="getGrid"
              v-if="formLanguages.includes('dari') && (beingEditedFieldType == 'text' || beingEditedFieldType == 'textarea' || beingEditedFieldType == 'percentage')">
              <p class="field_label">محل نگهدارنده</p>
              <va-input v-model="fieldDariPlaceholder" showClean placeholder="محل نگهدارنده"
                name="fieldDariPlaceholder" />
            </va-column>
          </va-row>

          <!-- only for multichoise fields -->
          <va-form type="vertical" ref="optionsForm"
            v-if="beingEditedFieldType == 'select' || beingEditedFieldType == 'multiple-option' || beingEditedFieldType == 'single-option'">

            <va-row
              v-if="(formStatus == 'new' || (viewedForm && (viewedForm.get('status') == 'pending' || !openedField.isPrevious)))"
              style="margin: 15px 0">
              <va-column :lg="6" :md="6" :sm="6" :xm="6">
                <p class="field_label">{{ _('Value to store in database') }}</p>
                <va-radio-group v-model="multiChoiseFieldLanguage" required :key="lang_key">

                  <va-radio v-for="(lang, index) in formLanguages" :label="lang">{{
                    _(lang) }}</va-radio>

                </va-radio-group>
              </va-column>
            </va-row>

            <va-row>
              <va-column :lg="12" :md="12" :sm="12" :xs="12">
                <va-table hover fullWidth>
                  <table>
                    <thead>
                      <th v-if="formLanguages.includes('english')">English</th>
                      <th v-if="formLanguages.includes('pashto')">پښتو</th>
                      <th v-if="formLanguages.includes('dari')">دری</th>
                      <th
                        v-if="(formStatus == 'new' || (viewedForm && (viewedForm.get('status') == 'pending' || !openedField.isPrevious))) && multiChoiseOptions.length != 2">
                        {{ _('Actions') }}</th>
                    </thead>
                    <tbody>
                      <tr
                        v-if="beingEditedFieldType == 'multiple-option' || beingEditedFieldType == 'select' || beingEditedFieldType == 'single-option'"
                        v-for="(option, index) in multiChoiseOptions">
                        <td class="smallTd" v-if="formLanguages.includes('english')">
                          <va-input
                            :disabled="viewedForm != null && viewedForm.get('status') != 'pending' && multiChoiseFieldLanguage == 'english' && !option.isPrevious"
                            :rules="[{type:'required'}]" class="man" v-model="option.englishLabel"
                            placeholder="Option label" @keyup.native.enter="addMultiChoiseOption(index)"></va-input>
                        </td>
                        <td class="smallTd" v-if="formLanguages.includes('pashto')">
                          <va-input
                            :disabled="viewedForm != null && viewedForm.get('status') != 'pending' && multiChoiseFieldLanguage == 'pashto' && !option.isPrevious"
                            :rules="[{type:'required'}]" class="man" v-model="option.pashtoLabel"
                            placeholder="انتخاب نوم" @keyup.native.enter="addMultiChoiseOption(index)"></va-input>
                        </td>
                        <td class="smallTd" v-if="formLanguages.includes('dari')">
                          <va-input
                            :disabled="viewedForm != null && viewedForm.get('status') != 'pending' && multiChoiseFieldLanguage == 'dari' && !option.isPrevious"
                            :rules="[{type:'required'}]" class="man" v-model="option.dariLabel" placeholder="نام انتخاب"
                            @keyup.native.enter="addMultiChoiseOption(index)"></va-input>
                        </td>
                        <td
                          v-if="(formStatus == 'new' || (viewedForm && (viewedForm.get('status') == 'pending' || !openedField.isPrevious))) && multiChoiseOptions.length != 1">
                          <va-button @click.native="deleteOption(index)">
                            <va-icon type="times"></va-icon>
                          </va-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </va-table>
              </va-column>
            </va-row>

            <va-row :gutter="0">
              <va-column :lg="3" :md="3" :sm="3" :xm="3">
                <va-button type="primary" @click.native="addMultiChoiseOption">{{ _('Add') }}</va-button>
              </va-column>
            </va-row>
          </va-form>
        </div>

        <va-row :gutter="0" v-if="showError">
          <va-column :lg="12" :md="12" :sm="12">
            <p style="color: red">{{ errorMessage }}</p>
          </va-column>
        </va-row>

      </div>
    </va-modal>
  </div>
</template>

<script>
  // @ is an alias to /src
  import Parse from "@/main.js"
  import draggable from 'vuedraggable'
  import { mapGetters, mapActions } from "vuex";

  export default {

    components: {
      draggable
    },

    props: {
      viewedForm: Object,
      viewedFormLayout: Array,
      selectedFields: Array,
      formLanguages: {
        type: Array,
        default: function () {
          return ['english']
        }
      }
    },

    data() {
      return {
        components: [
          {
            englishLabel: "Heading",
            pashtoLabel: "سرلیک",
            dariLabel: "عنوان",
            type: "heading",
            isPrevious: false
          },
          {
            englishLabel: "Description",
            pashtoLabel: 'تفصیل',
            dariLabel: 'تفصیل',
            type: "description",
            isPrevious: false
          },
          {
            englishLabel: "Small Text",
            pashtoLabel: 'کوچنۍ متن',
            dariLabel: 'متن کوچک',
            type: "text",
            fieldEnglishPlaceholder: 'Small text',
            fieldPashtoPlaceholder: 'کوچنۍ متن',
            fieldDariPlaceholder: 'متن کوچک',
            fieldType: 'text',
            isPrevious: false
          },
          {
            englishLabel: "Large Text",
            pashtoLabel: 'لوی متن',
            dariLabel: 'متن بزرگ',
            type: "textarea",
            fieldEnglishPlaceholder: 'Large text',
            fieldPashtoPlaceholder: 'لوی متن',
            fieldDariPlaceholder: 'متن بزرگ',
            isPrevious: false
          },
          {
            englishLabel: "Date",
            pashtoLabel: 'نیټه',
            dariLabel: 'تاریخ',
            type: "date",
            isPrevious: false
          },
          {
            englishLabel: "Yes / No",
            pashtoLabel: 'هو / نه',
            dariLabel: 'بلی / نخیر',
            type: "checkbox",
            isPrevious: false
          },
          {
            englishLabel: "Multiple Option",
            pashtoLabel: 'څو اختیار',
            dariLabel: 'گزینه چندگانه',
            type: "multiple-option",
            optionValueInDatabase: 'english',
            isPrevious: false,
            options: [
              { englishLabel: 'Option 1', pashtoLabel: 'لوړۍ انتخاب', dariLabel: 'انتخاب اول', selected: false, value: 'Option 1', isPrevious: false },
              { englishLabel: 'Option 2', pashtoLabel: 'دویم انتخاب', dariLabel: 'انتخاب دوم', selected: false, value: 'Option 2', isPrevious: false }
            ]
          },
          {
            englishLabel: "Single Option",
            pashtoLabel: 'یواځې اختیار',
            dariLabel: 'گزینه تک',
            type: "single-option",
            optionValueInDatabase: 'english',
            isPrevious: false,
            options: [
              { englishLabel: 'Option 1', pashtoLabel: 'لوړۍ انتخاب', dariLabel: 'انتخاب اول', selected: false, value: 'Option 1', isPrevious: false },
              { englishLabel: 'Option 2', pashtoLabel: 'دویم انتخاب', dariLabel: 'انتخاب دوم', selected: false, value: 'Option 2', isPrevious: false }
            ]
          },
          {
            englishLabel: 'List Selection',
            pashtoLabel: 'غوره کول له لیست',
            dariLabel: 'انتخاب لیست',
            type: 'select',
            multiple: false,
            optionValueInDatabase: '',
            isPrevious: false,
            options: [
              { englishLabel: 'Option 1', pashtoLabel: 'لوړۍ انتخاب', dariLabel: 'انتخاب اول', selected: false, value: 'Option 1', isPrevious: false },
              { englishLabel: 'Option 2', pashtoLabel: 'دویم انتخاب', dariLabel: 'انتخاب دوم', selected: false, value: 'Option 2', isPrevious: false }
            ]
          },
          {
            englishLabel: 'Single Geo Location',
            pashtoLabel: 'ځای',
            dariLabel: 'مکان',
            type: 'single-geolocation',
            isPrevious: false
          },
          {
            englishLabel: 'Multiple Geo Locations',
            pashtoLabel: 'ځای',
            dariLabel: 'مکان',
            type: 'multiple-geolocation',
            isPrevious: false
          },
          {
            englishLabel: "Attachment",
            pashtoLabel: 'ضمیمه',
            dariLabel: 'ضمیمه',
            type: "attachment",
            multiple: false,
            isPrevious: false
          },
        ],


        icons: {
          'heading': "heading",
          'description': "description",
          'attachment': "attachment",
          'date': "date",
          'checkbox': "yes-no",
          'multiple-option': "multiple-option-2",
          'single-option': "single-option-2",
          'text': "small-text",
          'textarea': "large-text",
          'select': 'list-selection',
          'grid': "grid-selection",
          'single-geolocation': 'single-geolocation',
          'multiple-geolocation': 'multiple-geolocation'
        },
        formFields: [],

        disableSingleGeolocation: false,


        openedField: {},

        isDragging: false,
        isDragged: false,
        delayedDragging: false,
        dropArea: 'dropArea',
        dropAreaPashto: 'dropAreaPashto',
        dropAreaDari: 'dropAreaDari',

        // current field edit
        beingEditedFieldType: '',
        beingEditedFieldName: '',
        beingEditedFieldDatabaseName: '',
        isRequired: true,
        multipleSelection: false,
        editable: true,
        isTime: false,
        isHijri: false,

        englishLabel: '',
        pashtoLabel: '',
        dariLabel: '',

        fieldEnglishNote: '',
        fieldPashtoNote: '',
        fieldDariNote: '',

        fieldEnglishPlaceholder: '',
        fieldPashtoPlaceholder: '',
        fieldDariPlaceholder: '',

        englishHeading: '',
        pashtoHeading: '',
        dariHeading: '',

        englishDescription: '',
        pashtoDescription: '',
        dariDescription: '',

        multiChoiseFieldLanguage: '',

        textFieldType: 'text',

        fieldDatabaseName2: '',
        englishFieldNameForDatabase: '',
        pashtoFieldNameForDatabase: '',
        dariFieldNameForDatabase: '',

        showError: false,
        errorMessage: '',

        multiChoiseOptions: [],

        showFieldDatabaseNameInput: false,
        userIsTyping: true,
        singleOptionChecked: '',

        valueTypeToStore: 'english',

        formId: this.$route.params.id,
        // viewedForm: null,

        foundDuplicate: false,
        lang_key: '',
        form_key: '',
      };
    },

    watch: {

      viewedFormLayout: function (val) {
        this.formFields = this.viewedFormLayout.map(field => {
          return { ...field, isPrevious: true }
        })
      },


      formLanguages(val) {

        this.multiChoiseFieldLanguage = val[0];
        this.lang_key = Date.now();
      },

      // this is for input
      fieldDatabaseName2: function (val) {
        this.fieldDatabaseName2 = this.fieldDatabaseName2.slugify();
      },

      englishFieldNameForDatabase: function (val) {
        if (val && val.length <= 30) {
          this.englishFieldNameForDatabase = this.englishFieldNameForDatabase.replace(/[0-9]/g, '').slugify()
        } else if (val && val.length > 30) {
          this.englishFieldNameForDatabase = this.englishFieldNameForDatabase.substring(0, 30).replace(/[0-9]/g, '').slugify()
          this.errorMessage = this._('Field database name cannot be over 30 characters (will be stripped to 30 characters)')
          this.showError = true
        }
        // this.englishFieldNameForDatabase = this.englishFieldNameForDatabase.slugify()
      },

      pashtoFieldNameForDatabase: function (val) {
        if (val && val.length <= 30) {
          this.pashtoFieldNameForDatabase = this.pashtoFieldNameForDatabase.replace(/[0-9]/g, '').slugify()
        } else if (val && val.length > 30) {
          this.errorMessage = this._('Field database name cannot be over 30 characters (will be stripped to 30 characters)')
          this.showError = true
          this.pashtoFieldNameForDatabase = this.pashtoFieldNameForDatabase.substring(0, 30).replace(/[0-9]/g, '').slugify()
        }
        // this.pashtoFieldNameForDatabase = this.pashtoFieldNameForDatabase.replace(/[0-9]/g, '').slugify()
      },

      dariFieldNameForDatabase: function (val) {
        if (val && val.length <= 30) {
          this.dariFieldNameForDatabase = this.dariFieldNameForDatabase.replace(/[0-9]/g, '').slugify()
        } else if (val && val.length > 30) {
          this.errorMessage = this._('Field database name cannot be over 30 characters (will be stripped to 30 characters)')
          this.showError = true
          this.dariFieldNameForDatabase = this.dariFieldNameForDatabase.substring(0, 30).replace(/[0-9]/g, '').slugify()
        }
        // this.dariFieldNameForDatabase = this.dariFieldNameForDatabase.replace(/[0-9]/g, '').slugify()
      },


      englishLabel: function (val) {
        if (this.multiChoiseFieldLanguage == 'english') {
          if (val !== '') {
            this.userIsTyping = true
          } else {
            this.userIsTyping = false
          }
        }
      },

      pashtoLabel: function (val) {
        if (this.multiChoiseFieldLanguage == 'pashto') {
          if (val !== '') {
            this.userIsTyping = true
          } else {
            this.userIsTyping = false
          }
        }
      },

      dariLabel: function (val) {
        if (this.multiChoiseFieldLanguage == 'dari') {
          if (val !== '') {
            this.userIsTyping = true
          } else {
            this.userIsTyping = false
          }
        }
      },

      formFields: function (val) {
        this.$emit('update:selectedFields', val)
      },

      formLanguages: function (val) {
        this.$emit('update:formLanguages', val)
      }
    },

    computed: {
      ...mapGetters(['getSystemLanguage', 'user', 'getCurrentFormFromState']),

      getFieldDatabaseNameTitle() {

        if (this.formLanguages[0] == 'pashto') return 'د ډېټابېس لپاره د پوښتنې انګليسي نوم'
        else if (this.formLanguages[0] == 'english') return 'field name for database'
        else return 'اسم سوال در انګلیسی برای دیتابیس'

      },

      getGrid() {
        if (this.formLanguages.length == 1) return 12
        else if (this.formLanguages.length == 2) return 6
        else return 4
      },


      formStatus() {
        if (this.viewedForm != null) {
          return this.viewedForm.get('status')
        } else {
          return 'new'
        }

      },

      componentsOptions() {
        return {
          sort: false,
          group: {
            name: 'components',
            pull: 'clone',
            put: false
          }
        }
      },

      formOptions() {
        return {
          handle: '.collapsible-header',
          group: {
            name: 'components'
          },
          animation: 150,
          touchStartThreshold: 100
        }
      },

      currentFormFields() {
        return this.formFields;
      },

      fieldDatabaseName() {
        return this.openedField.fieldDatabaseName
      },

      getFieldDatabaseNameLabel() {
        if (this.multiChoiseFieldLanguage == 'english') return 'field name in english'
        else if (this.multiChoiseFieldLanguage == 'pashto') return 'پوښتنه نوم په پښتو *'
        else return 'اسم سوال در دری *'
      }
    },


    methods: {
      ...mapActions(['setFormBuilderFields', 'setCurrentFormToState']),

      setMultipleSelectionValue(val) {
        this.multipleSelection = val
      },

      setFieldEditableValue(val) {
        this.editable = val
      },

      setFieldIsTimeValue(val) {
        this.isTime = val
      },

      setFieldIsHijriValue(val) {
        this.isHijri = val;
      },

      getPlaceholder(item) {
        if (this.getSystemLanguage == 'dari') {
          if (this.formLanguages.includes('dari')) return item.fieldDariPlaceholder
          else {
            if (this.formLanguages[0] == 'pashto') return item.fieldPashtoPlaceholder
            else return item.fieldEnglishPlaceholder
          }
        }

        if (this.getSystemLanguage == 'pashto') {
          if (this.formLanguages.includes('pashto')) return item.fieldPashtoPlaceholder
          else {
            if (this.formLanguages[0] == 'dari') return item.fieldDariPlaceholder
            else return item.fieldEnglishPlaceholder
          }
        } else {
          if (this.formLanguages.includes('english')) return item.fieldEnglishPlaceholder
          else {
            if (this.formLanguages[0] == 'pashto') return item.fieldPashtoPlaceholder
            else return item.fieldDariPlaceholder
          }
        }
      },

      getItemNote(item) {

        if (this.getSystemLanguage == 'dari') {
          if (this.formLanguages.includes('dari')) return item.dariNote
          else {
            if (this.formLanguages[0] == 'pashto') return item.pashtoNote
            else return item.englishNote
          }
        }

        if (this.getSystemLanguage == 'pashto') {
          if (this.formLanguages.includes('pashto')) return item.pashtoNote
          else {
            if (this.formLanguages[0] == 'dari') return item.dariNote
            else return item.englishNote
          }


        } else {
          if (this.formLanguages.includes('english')) return item.englishNote
          else {
            if (this.formLanguages[0] == 'pashto') return item.pashtoNote
            else return item.dariNote
          }
        }
      },

      getItemLabel(item) {
        if (this.getSystemLanguage == 'dari') {
          if (this.formLanguages.includes('dari')) return item.dariLabel
          else {
            if (this.formLanguages[0] == 'pashto') return item.pashtoLabel
            else return item.englishLabel
          }
        }

        if (this.getSystemLanguage == 'pashto') {
          if (this.formLanguages.includes('pashto')) return item.pashtoLabel
          else {
            if (this.formLanguages[0] == 'dari') return item.dariLabel
            else return item.englishLabel
          }


        } else {
          if (this.formLanguages.includes('english')) return item.englishLabel
          else {
            if (this.formLanguages[0] == 'pashto') return item.pashtoLabel
            else return item.dariLabel
          }
        }
      },

      getComponentLabel(component) {
        if (this.getSystemLanguage == 'dari') {
          return component.dariLabel
        } else if (this.getSystemLanguage == 'pashto') {
          return component.pashtoLabel
        } else return component.englishLabel
      },

      showFieldDatabaseNameTextInput() {
        this.showFieldDatabaseNameInput = true
        if (this.formLanguages[0] == 'english') this.englishFieldNameForDatabase = this.fieldDatabaseName
        else if (this.formLanguages[0] == 'pashto') this.pashtoFieldNameForDatabase = this.fieldDatabaseName
        else this.dariFieldNameForDatabase = this.fieldDatabaseName
      },

      addMultiChoiseOption(index) {
        var lastValue = this.multiChoiseOptions[this.multiChoiseOptions.length - 1]
        for (var i = 0; i < this.multiChoiseOptions.length - 1; i++) {
          if ((lastValue.englishLabel == this.multiChoiseOptions[i].englishLabel && this.formLanguages.includes('english')) || (lastValue.pashtoLabel == this.multiChoiseOptions[i].pashtoLabel && this.formLanguages.includes('pashto')) || (lastValue.dariLabel == this.multiChoiseOptions[i].dariLabel && this.formLanguages.includes('dari'))) {
            this.showError = true;
            this.errorMessage = this._('Duplicate option')
            return false
          }
        }
        if ((lastValue.englishLabel == '' && this.formLanguages.includes('english')) || (lastValue.pashtoLabel == '' && this.formLanguages.includes('pashto')) || (lastValue.dariLabel == '' && this.formLanguages.includes('dari'))) {
          this.showError = true;
          this.errorMessage = this._('Please provide option labels')
          return false
        } else {
          this.showError = false
          this.multiChoiseOptions.push({
            englishLabel: '',
            pashtoLabel: '',
            dariLabel: '',
            selected: false,
            value: '',
            isPrevious: true
          })
        }
      },

      deleteOption(index) {
        this.multiChoiseOptions.splice(index, 1);
      },

      editField(name, type, fieldDatabaseName) {
        this.beingEditedFieldType = type
        this.beingEditedFieldName = name
        this.beingEditedFieldDatabaseName = fieldDatabaseName

        this.formFields.forEach(field => {
          if (field.name == name) {

            this.openedField = field;
            if (type == 'heading') {
              this.englishHeading = field.englishLabel
              this.pashtoHeading = field.pashtoLabel
              this.dariHeading = field.dariLabel

            } else if (type == 'description') {
              this.englishDescription = field.englishLabel
              this.pashtoDescription = field.pashtoLabel
              this.dariDescription = field.dariLabel

            } else {
              this.editable = field.editable
              this.englishLabel = field.englishLabel
              this.pashtoLabel = field.pashtoLabel
              this.dariLabel = field.dariLabel

              this.fieldEnglishNote = field.englishNote
              this.fieldPashtoNote = field.pashtoNote
              this.fieldDariNote = field.dariNote

              this.isRequired = field.required

              if (type == 'text') this.textFieldType = field.fieldType
              if (type == 'date') {
                this.isTime = field.isTime
                this.isHijri = field.isHijri
              }

              if (type == 'attachment') this.multipleSelection = field.multiple

              else if (type == 'text' || type == 'textarea') {
                this.fieldEnglishPlaceholder = field.fieldEnglishPlaceholder
                this.fieldPashtoPlaceholder = field.fieldPashtoPlaceholder
                this.fieldDariPlaceholder = field.fieldDariPlaceholder

              } else if (type == 'select') {

                if (this.formLanguages.includes(field.optionValueInDatabase)) {
                  this.multiChoiseFieldLanguage = field.optionValueInDatabase || this.formLanguages[0];
                } else {
                  this.multiChoiseFieldLanguage = this.formLanguages[0];
                }

                field.options.forEach(option => {
                  this.multiChoiseOptions.push({ englishLabel: option.englishLabel, pashtoLabel: option.pashtoLabel, dariLabel: option.dariLabel, selected: option.selected, value: option.value })
                })
                this.multipleSelection = field.multiple

              } else if (type == 'multiple-option') {

                if (this.formLanguages.includes(field.optionValueInDatabase)) {
                  this.multiChoiseFieldLanguage = field.optionValueInDatabase || this.formLanguages[0];
                } else {
                  this.multiChoiseFieldLanguage = this.formLanguages[0];
                }
                field.options.forEach(option => {
                  this.multiChoiseOptions.push({ englishLabel: option.englishLabel, pashtoLabel: option.pashtoLabel, dariLabel: option.dariLabel, selected: option.selected, value: option.value })
                })

              } else if (type == 'single-option') {
                if (this.formLanguages.includes(field.optionValueInDatabase)) {
                  this.multiChoiseFieldLanguage = field.optionValueInDatabase || this.formLanguages[0];
                } else {
                  this.multiChoiseFieldLanguage = this.formLanguages[0];
                }
                field.options.forEach(option => {
                  this.multiChoiseOptions.push({ englishLabel: option.englishLabel, pashtoLabel: option.pashtoLabel, dariLabel: option.dariLabel, selected: option.selected, value: option.value })
                })
              }

              this.showFieldDatabaseNameInput = false
              if (field.fieldDatabaseName == '') {

                field.fieldDatabaseName = field.englishLabel.slugify()
              } else {

                field.fieldDatabaseName = field.fieldDatabaseName
              }
            }
          }
        })
        this.$refs.editFieldModal.open()
      },

      checkDuplicate(currentField) {
        var dups = []
        for (const key in this.formFields) {
          let field = this.formFields[key]
          if (field.type != 'heading' && field.type != 'description' && field.fieldDatabaseName == currentField.fieldDatabaseName && currentField.name != field.name) {
            dups.push(field)
          }
        }
        return dups
      },

      checkDuplicateOptions(array) {
        for (var i = 0; i < array.length; i++) {
          for (var j = i; j < array.length; j++) {
            if (i != j) {
              if ((this.formLanguages.includes('english') && array[i].englishLabel == array[j].englishLabel) || (this.formLanguages.includes('pashto') && array[i].pashtoLabel == array[j].pashtoLabel) || (this.formLanguages.includes('dari') && array[i].dariLabel == array[j].dariLabel)) {
                return true
              }
            }
          }
        }
        return false;
      },

      confirmEditField() {
        for (const key in this.formFields) {
          var field = this.formFields[key]


          if (field.name == this.beingEditedFieldName) {
            var previouseDBName = field.fieldDatabaseName
            // database field name setting
            if (this.formStatus == 'new' || (this.viewedForm && (this.viewedForm.get('status') == 'pending' || !field.isPrevious))) {
              if (this.showFieldDatabaseNameInput) {
                // if manual
                if (this.formLanguages[0] == 'english') {
                  if (this.englishFieldNameForDatabase == 'department' || this.englishFieldNameForDatabase == 'category' || this.englishFieldNameForDatabase == 'form' || this.englishFieldNameForDatabase == 'latitude' || this.englishFieldNameForDatabase == 'longitude' || this.englishFieldNameForDatabase == 'status' || this.englishFieldNameForDatabase == 'createdby' || this.englishFieldNameForDatabase == 'createdat' || this.englishFieldNameForDatabase == 'updatedat' || this.englishFieldNameForDatabase == 'acl' || this.englishFieldNameForDatabase == 'objectid' || this.englishFieldNameForDatabase == 'approvalby' || this.englishFieldNameForDatabase == 'submission_language') {
                    this.$notify({
                      group: 'foo',
                      text: this._(this.englishFieldNameForDatabase + ' is a reserved word'),
                      duration: 4000,
                      position: 'top left',
                      type: 'error'
                    });
                    return false;
                  }
                  else
                    field.fieldDatabaseName = this.englishFieldNameForDatabase
                } else if (this.formLanguages[0] == 'pashto')
                  if (this.pashtoFieldNameForDatabase == 'department' || this.pashtoFieldNameForDatabase == 'category' || this.pashtoFieldNameForDatabase == 'form' || this.pashtoFieldNameForDatabase == 'latitude' || this.pashtoFieldNameForDatabase == 'longitude' || this.pashtoFieldNameForDatabase == 'status' || this.pashtoFieldNameForDatabase == 'createdby' || this.pashtoFieldNameForDatabase == 'createdat' || this.pashtoFieldNameForDatabase == 'updatedat' || this.pashtoFieldNameForDatabase == 'acl' || this.pashtoFieldNameForDatabase == 'objectid' || this.pashtoFieldNameForDatabase == 'approvalby' || this.pashtoFieldNameForDatabase == 'submission_language') {
                    this.$notify({
                      group: 'foo',
                      text: this._(this.pashtoFieldNameForDatabase + ' is a reserved word'),
                      duration: 4000,
                      position: 'top left',
                      type: 'error'
                    });
                    return false;
                  }
                  else
                    field.fieldDatabaseName = this.pashtoFieldNameForDatabase

                else {
                  if (this.dariFieldNameForDatabase == 'department' || this.dariFieldNameForDatabase == 'category' || this.dariFieldNameForDatabase == 'form' || this.dariFieldNameForDatabase == 'latitude' || this.dariFieldNameForDatabase == 'longitude' || this.dariFieldNameForDatabase == 'status' || this.dariFieldNameForDatabase == 'createdby' || this.dariFieldNameForDatabase == 'createdat' || this.dariFieldNameForDatabase == 'updatedat' || this.dariFieldNameForDatabase == 'acl' || this.dariFieldNameForDatabase == 'objectid' || this.dariFieldNameForDatabase == 'approvalby' || this.dariFieldNameForDatabase == 'submission_language') {
                    this.$notify({
                      group: 'foo',
                      text: this._(this.dariFieldNameForDatabase + ' is a reserved word'),
                      duration: 4000,
                      position: 'top left',
                      type: 'error'
                    });
                    return false;
                  }
                  else field.fieldDatabaseName = this.dariFieldNameForDatabase
                }

              } else {
                // this is the real approach
                // field.fieldDatabaseName = this.fieldDatabaseName


                // this is new approach, needs thinking and testing
                var fieldDatabaseName = '';
                if (this.formLanguages.includes('english')) {
                  fieldDatabaseName = this.englishLabel.replace(/[0-9]/g, '').slugify()
                } else if (this.formLanguages.includes('pashto')) {
                  fieldDatabaseName = this.pashtoLabel.replace(/[0-9]/g, '').slugify()
                } else if (this.formLanguages.includes('dari')) {
                  fieldDatabaseName = this.dariLabel.replace(/[0-9]/g, '').slugify()
                }

                if (fieldDatabaseName == 'department' || fieldDatabaseName == 'category' || fieldDatabaseName == 'form' || fieldDatabaseName == 'latitude' || fieldDatabaseName == 'longitude' || fieldDatabaseName == 'status' || fieldDatabaseName == 'createdby' || fieldDatabaseName == 'createdat' || fieldDatabaseName == 'updatedat' || fieldDatabaseName == 'acl' || fieldDatabaseName == 'objectid' || fieldDatabaseName == 'approvalby' || fieldDatabaseName == 'submission_language') {
                  this.$notify({
                    group: 'foo',
                    text: this._(fieldDatabaseName + ' is a reserved word'),
                    duration: 4000,
                    position: 'top left',
                    type: 'error'
                  });
                  return false;
                }
                else {
                  if (fieldDatabaseName.length > 30) {
                    this.$notify({
                      group: 'foo',
                      text: this._('Field database name cannot be over 30 characters'),
                      duration: 4000,
                      position: 'top left',
                      type: 'error'
                    });
                    return false;
                  }
                }
                field.fieldDatabaseName = fieldDatabaseName
              }
            }

            if (this.checkDuplicate(field).length != 0) {
              this.errorMessage = this._('Duplicate database field name')
              this.showError = true
              this.englishFieldNameForDatabase = field.fieldDatabaseName
              field.fieldDatabaseName = previouseDBName
              return false
            }

            // heading
            if (this.beingEditedFieldType == 'heading') {
              if ((this.englishHeading == '' && this.formLanguages.includes('english')) || (this.pashtoHeading == '' && this.formLanguages.includes('pashto')) || (this.dariHeading == '' && this.formLanguages.includes('dari'))) {
                this.errorMessage = this._('Please fill the fields with ( * ) sign')
                this.showError = true
              } else {
                field.englishLabel = this.englishHeading
                field.pashtoLabel = this.pashtoHeading
                field.dariLabel = this.dariHeading
                this.$refs.editFieldModal.close()
              }

              // description
            } else if (this.beingEditedFieldType == 'description') {
              if ((this.englishDescription == '' && this.formLanguages.includes('english')) || (this.pashtoDescription == '' && this.formLanguages.includes('pashto')) || (this.dariDescription == '' && this.formLanguages.includes('dari'))) {
                this.errorMessage = this._('Please fill the field with ( * ) sign')
                this.showError = true
              } else {
                field.englishLabel = this.englishDescription
                field.pashtoLabel = this.pashtoDescription
                field.dariLabel = this.dariDescription

                this.$refs.editFieldModal.close()
              }

              // options
            } else if (this.beingEditedFieldType == 'multiple-option' || this.beingEditedFieldType == 'select' || this.beingEditedFieldType == 'single-option') {
              if (!this.checkDuplicateOptions(this.multiChoiseOptions)) {
                let fieldLabels = {
                  englishLabel: this.englishLabel,
                  pashtoLabel: this.pashtoLabel,
                  dariLabel: this.dariLabel
                }

                let checks = [];
                this.multiChoiseOptions.forEach(option => {
                  if ((option.englishLabel == '' && this.formLanguages.includes('english')) || (option.pashtoLabel == '' && this.formLanguages.includes('pashto')) || (option.dariLabel == '' && this.formLanguages.includes('dari'))) {
                    this.showError = true
                    this.errorMessage = this._('Please provide option labels')
                    checks.push(true);
                  }
                  else if ((fieldLabels.englishLabel == '' && this.formLanguages.includes('english')) || (fieldLabels.pashtoLabel == '' && this.formLanguages.includes('pashto')) || (fieldLabels.dariLabel == '' && this.formLanguages.includes('dari'))) {
                    this.showError = true
                    this.errorMessage = this._('Please provide field in selected languages')
                    checks.push(true)
                  }

                });

                if (checks.length == 0) {
                  if (this.multiChoiseOptions.length < 2) {
                    this.showError = true
                    this.errorMessage = this._('Atleast 2 options are required')
                  } else {
                    field.editable = this.editable
                    field.englishLabel = this.englishLabel
                    field.pashtoLabel = this.pashtoLabel
                    field.dariLabel = this.dariLabel


                    this.multiChoiseOptions.forEach(option => {
                      if (this.multiChoiseFieldLanguage == 'english') {
                        option.value = option.englishLabel.trim()
                      } else if (this.multiChoiseFieldLanguage == 'pashto') {
                        option.value = option.pashtoLabel.trim()
                      } else {
                        option.value = option.dariLabel.trim()
                      }
                    })
                    field.options = [...this.multiChoiseOptions]
                    field.optionValueInDatabase = this.multiChoiseFieldLanguage

                    field.englishNote = this.fieldEnglishNote
                    field.pashtoNote = this.fieldPashtoNote
                    field.dariNote = this.fieldDariNote
                    field.required = this.isRequired
                    this.$refs.editFieldModal.close()
                  }
                }

                if ((this.formStatus == 'new' || (this.viewedForm && (this.viewedForm.get('status') == 'pending' || !field.isPrevious))) && field.type == 'select') {
                  field.multiple = this.multipleSelection
                }
              } else {
                this.showError = true;
                this.errorMessage = this._('Duplicate option')
              }
              // everything else (text, textarea, date, checkbox, attachment, geolocation)
            } else {
              if ((this.englishLabel == '' && this.formLanguages.includes('english')) || (this.pashtoLabel == '' && this.formLanguages.includes('pashto')) || (this.dariLabel == '' && this.formLanguages.includes('dari'))) {
                this.errorMessage = this._('Please provide field in selected languages')
                this.showError = true
              } else {
                if ((this.formStatus == 'new' || (this.viewedForm && (this.viewedForm.get('status') == 'pending' || !field.isPrevious)))) {
                  if (field.type == 'date') {
                    field.isTime = this.isTime
                    field.isHijri = this.isHijri
                  }
                  if (field.type == 'text') field.fieldType = this.textFieldType
                  if (field.type == 'attachment') field.multiple = this.multipleSelection
                }
                field.editable = this.editable
                if (field.type == 'textarea' || field.type == 'text') {
                  field.fieldEnglishPlaceholder = this.fieldEnglishPlaceholder
                  field.fieldPashtoPlaceholder = this.fieldPashtoPlaceholder
                  field.fieldDariPlaceholder = this.fieldDariPlaceholder
                }


                field.englishLabel = this.englishLabel
                field.pashtoLabel = this.pashtoLabel
                field.dariLabel = this.dariLabel

                field.englishNote = this.fieldEnglishNote
                field.pashtoNote = this.fieldPashtoNote
                field.dariNote = this.fieldDariNote

                field.required = this.isRequired
                this.$refs.editFieldModal.close()
              }
            }
          }
        }
      },


      hideEditField() {
        this.editable = true
        this.isTime = false
        this.isHijri = false
        this.beingEditedFieldName = ''
        this.beingEditedFieldType = ''
        this.textFieldType = 'text'
        this.showFieldDatabaseNameInput = false
        this.showError = false
        this.errorMessage = ''
        this.englishLabel = ''
        this.pashtoLabel = ''
        this.dariLabel = ''
        this.fieldEnglishNote = ''
        this.englishFieldNameForDatabase = ''
        this.pashtoFieldNameForDatabase = ''
        this.dariFieldNameForDatabase = ''
        this.fieldDariNote = ''
        this.fieldPashtoNote = ''
        this.isRequired = true
        this.fieldEnglishPlaceholder = ''
        this.fieldPashtoPlaceholder = ''
        this.fieldDariPlaceholder = ''
        this.englishHeading = ''
        this.pashtoHeading = ''
        this.dariHeading = ''
        this.englishDescription = ''
        this.pashtoDescription = ''
        this.dariDescription = ''
        this.multipleSelection = false
        this.multiChoiseOptions = []
      },

      onMove({
        relatedContext,
        draggedContext
      }) {
        const relatedElement = relatedContext.element;
        const draggedElement = draggedContext.element;
        return (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      },

      isBeingDragged(el) {
        if (this.$refs['itm_' + el])
          if (this.$refs['itm_' + el][0])
            return this.$refs['itm_' + el][0].draggable;
        return false
        //   ;
      },

      onClone(el) {


        var input = JSON.parse(JSON.stringify(el));
        input.name = input.type + '-' + Date.now();

        if (input.type == 'single-geolocation' && this.formFields.some(item => item.type == "single-geolocation")) {
          this.$notify({
            group: 'foo',
            text: this._('You can only add one single geolocation field'),
            duration: 4000,
            position: 'top left',
            type: 'error'
          });
          return;
        }

        if (input.type != 'heading' && input.type != 'description') {
          input.englishNote = '';
          input.pashtoNote = '';
          input.dariNote = '';
          input.required = true;
          input.optionValueInDatabase = this.formLanguages[0]
        }
        input.fixed = false;


        function getNewName(s, arr) {
          let temp_name = s;
          let last_num = -1;
          arr.forEach(q => {
            let item = q.englishLabel;
            let new_num = 0;
            if (item.search(/ \d+$/) > -1) {
              new_num = parseInt(item.substr(item.search(/ \d+$/) + 1));
            }
            if (s == item.replace(/ \d+$/, "")) {
              // 			new_num=new_num+1;
              if (new_num > last_num) last_num = new_num;
            }

          });

          if (last_num == -1) return s;
          if (last_num == 0) return s + ' 1';

          return s + ' ' + (last_num + 1);
        }

        input.englishLabel = getNewName(input.englishLabel, this.formFields);
        if (input.type != 'heading' && input.type != 'description') {
          input.fieldDatabaseName = input.englishLabel.slugify();
        }

        if (input.type == 'text')
          input.fieldType = 'text'
        return input
      },

      destroy(index) {
        this.formFields.splice(index, 1)
      },

      addOption(values) {
        values.push({
          label: "Option " + Date.now(),
          value: "option-" + Date.now()
        })
      },

      removeOption(values, index) {
        values.splice(index, 1)
      },

      clearItems() {
        this.formFields = [];
      },

      getIcon(type) {
        return require('../assets/' + this.icons[type] + '.png');
      }
    },

    async mounted() {

    }
  };
</script>

<style>
  .value_type .va-form-group {
    padding: 20px 0 !important;
    margin: 10px 0 0 -8px
      /* margin-left: -10px */
  }

  .hideRow {
    display: none;
  }

  .noselect {
    -webkit-touch-callout: none;
    /* iOS Safari */
    -webkit-user-select: none;
    /* Safari */
    -khtml-user-select: none;
    /* Konqueror HTML */
    -moz-user-select: none;
    /* Firefox */
    -ms-user-select: none;
    /* Internet Explorer/Edge */
    user-select: none;
    /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
  }

  .designForm {
    width: 60%;
    min-height: 450px;
    float: left;
    margin-bottom: 18px;
    display: flex;
    flex-direction: column;
    /* background: #fff; */
  }

  @media (max-width: 1324px) {
    .itemsForm .va-card {
      width: 100% !important
    }

    .itemsForm {
      margin-right: 0px
    }
  }

  .itemsForm {
    /* width: 30%;
    min-height: 370px;
    float: right;
     */
    /* min-width: 40%; */
    /* max-height: 65%;*/
    /* height: 65%; */
    overflow-y: auto;
    zoom: 0.7 !important;
    top: 300px !important;
    width: 30%;
    float: right;
    right: 0;
    margin-right: 90px;
    position: fixed !important;
    display: flex;
  }

  h3 {
    color: #8888 !important;
  }


  .pager {
    align-self: center;
  }

  .designFormInner {
    padding: 20px;
    background-color: #fff;

  }

  .itemssForm {
    width: 30%;
    height: 200px;
    float: right;
    background-color: #fff;
    border: 1px solid #8888;
    border-radius: 4px;
    box-shadow: 0px 0px 8px #0001;
    margin: 18px 0;
  }

  .dropArea {
    width: 100%;
    margin: 0px;
    padding: 10px;
  }

  .dropArea.empty {
    outline: 2px dashed #ddda;
    background: #ffe5;
    position: relative;
  }

  .dropArea.dragging {
    /* outline: 2px dashed #ddda; */
    /* background: #ffe5; */
    position: relative;
  }

  .dropArea.empty::after {
    content: 'Drop Fields Here';
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -150px;
    margin-top: -15px;
    font-size: 28pt;
    font-weight: bold;
    color: #ddd;
  }

  .dragArea {
    padding: 0;
    margin: 0;
  }

  .dropAreaPashto {
    width: 100%;
    margin: 0px;
    padding: 10px;
  }

  .dropAreaPashto.empty {
    outline: 2px dashed #ddda;
    background: #ffe5;
    position: relative;
  }

  .dropAreaPashto.dragging {
    /* outline: 2px dashed #ddda; */
    /* background: #ffe5; */
    position: relative;
  }

  .dropAreaPashto.empty::after {
    content: 'عناصر دلته واچوی';
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -150px;
    margin-top: -15px;
    font-size: 28pt;
    font-weight: bold;
    color: #ddd;
  }



  .dropAreaDari {
    width: 100%;
    margin: 0px;
    padding: 10px;
  }

  .dropAreaDari.empty {
    outline: 2px dashed #ddda;
    background: #ffe5;
    position: relative;
  }

  .dropAreaDari.dragging {
    /* outline: 2px dashed #ddda; */
    /* background: #ffe5; */
    position: relative;
  }

  .dropAreaDari.empty::after {
    content: 'عناصر را در اینجا بیاندازید';
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -150px;
    margin-top: -15px;
    font-size: 28pt;
    font-weight: bold;
    color: #ddd;
  }


  .collection-item {
    cursor: move;
    list-style: none;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ddd;

  }

  .collection-item_rtl {
    cursor: move;
    list-style: none;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    border-bottom: 1px solid #ddd;
  }

  .collection-item img {
    margin: 4px 20px;
    width: 32px;
    height: 32px;
  }

  .collection-item_rtl img {
    margin: 4px 20px;
    width: 32px;
    height: 32px;
  }

  .input-container {
    list-style: none;
    padding: 10px 0;
    cursor: move;
    zoom: 1;
  }

  .input-container>* {
    height: inherit;
  }


  .input-box:hover {
    padding-left: 10px;
    margin-left: -10px;
    margin-right: -10px;
    box-shadow: 0px 3px 10px #0002;
    background: #fff;
    outline: 2px dashed #444;
  }

  .input-box:hover .showButton {
    margin-top: -25px;
    margin-right: 1px;
    visibility: visible;

  }

  .showButton {
    visibility: hidden;
  }

  .select-border {
    border: 2px solid #dfe1e5;
  }

  .select-border .va-btn {
    background-color: #fafbfc !important;
  }

  .field_label {
    text-transform: uppercase;
    font-size: 0.8em;
    display: block;
    color: #848890;
    padding: 6px 1px;
  }

  .va-toast {
    z-index: 1000 !important;
    margin-top: -250px !important;
  }

  .sortable-ghost {
    opacity: 0;
  }

  .no-show {
    outline: 2px dashed #444;
  }

  .no-show * {
    opacity: 0;
  }

  .man {
    margin: 10px 10px 5px 20px !important;
  }

  .va-btn-danger {
    margin: 10px 10px 5px 5px !important;
  }

  .edit_title:hover {
    position: relative;
  }

  .edit_title:hover:before {
    content: '';
    background: #ffd;
    position: absolute;
    display: block;
    left: -8px;
    z-index: -1;
    border-radius: 3px;
    right: -10px;
    top: -8px;
    bottom: -8px;
  }



  .option_label .va-btn-group-vertical .va-checkbox-label {
    width: 500px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .multiple_geo {
    height: 200px;
  }

  .single_geo {
    height: 160px;
  }

  .item_border {
    border: 2px dashed rgb(0, 143, 0);
    padding: 10px;
    margin: 5px 0
  }

  .item_border:hover {
    border: none;
  }

  .input-box:hover .item_border {
    margin: 0;
    padding: 0;
  }
</style>